import { Routes } from '@angular/router';

export const addMultipleItemsRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./add-multiple-items.page').then((m) => m.AddMultipleItemsPage),
  },
];
